import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import iView from 'view-design' // 引入iview依赖
import 'view-design/dist/styles/iview.css' // 引入iview css样式
import 'hc-offcanvas-nav'
import 'lib-flexible'
import '@babel/polyfill'

import ECharts from 'vue-echarts' // refers to components/ECharts.vue in webpack
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/polar'
import 'echarts-gl'
Vue.component('v-chart', ECharts)

Vue.use(iView) //使用iview组件 
Vue.prototype.api = "/api/assets/fixed/meetingroom"
Vue.prototype.login = login
Vue.prototype.db_api = db_api
Vue.prototype._isMobile = _isMobile
Vue.prototype.logout = function (path) {
    logout()
    router.push({
        path: path || '/'
    })
}
Vue.prototype.base = router.options.subBase
router.beforeEach((to, from, next) => {
    console.log('[from to]', from, to)
    next()
})
Vue.config.productionTip = false
Vue.prototype.toLocaleDatetime = function (dt) {
    return formatDate(new Date(dt || Date.now()), 'yyyy-MM-dd hh:mm:ss')
}

function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
        }
    }
    return fmt;
}

let jwt = require('jsonwebtoken')

function check_login() {
    let token = store.state.global_token
    if (token) {
        let info = jwt.decode(token)
        if (!info || info.exp * 1000 < new Date().getTime()) {
            console.log(2222, info)
            logout()
        } else if (info.exp * 1000 - new Date().getTime() / 1000 < 5 * 60) {
            refresh_token()
        }
    }
}
check_login()
setInterval(check_login(), 60 * 1000)

async function get_userinfo() {
    return db_api('post', '/api/account/userinfo', {
        req: 'own_userinfo'
    })
        .then(r => {
            console.log(r)
            store.commit('setUser', r[0].result);
            console.log(store.state.user)
        })
        .catch(() => {
            store.commit('setUser', {})
        })
}

async function refresh_token() {
    db_api(
        'post',
        '/api/account/refresh_token', {}
    ).then(r => {
        store.commit('setGlobalToken', r[0].result)
        console.log('refreshed_token', r)
    })
}

async function db_api(method, url, param, token, headers = {
    "Content-Type": "application/json"
}) {
    token = token || token === undefined && store.state.global_token
    if (token) {
        headers.Authorization = "Bearer " + token;
    }
    if (param && !param.org_id) {
        param.org_id = 101100010080006
    }
    if (param) {
        param.terminal = 5
    }
    try {
        const response = await fetch(url, {
            method: method.toLocaleUpperCase(),
            mode: "cors",
            cache: "no-cache",
            headers: new Headers(headers),
            body: ['DELETE', 'GET'].indexOf(method.toLocaleUpperCase()) > -1 ? null : JSON.stringify(param)
        });
        let h = response.headers
        let s = response.status
        return response.text().then(async (r) => {
            if (!r || r === 'null') {
                return {
                    headers: h,
                    result: [],
                    status: s
                }
            } else {
                r = JSON.parse(r)
                if (r instanceof Array) {
                    return r
                } else {
                    if (r.message === 'JWT expired') {
                        logout()
                    } else if (r.message === 'expired token') {
                        iView.Message.warn('长期时间离开，刷新中 ~')
                        logout()
                    } else if (r.message === 'invalid username or password') {
                        console.log(r.message)
                        iView.Message.error('用户名 / 密码错误 ！')
                        router.push('/refresh')
                    } else if (r.message === 'exceed period') {
                        iView.Message.warn('该账户处于非在职状态 ！')
                        router.push('/refresh')
                    }
                    if (response.status >= 400) {
                        await fetch('/api/public/weblog', {
                            method: 'post',
                            headers,
                            body: JSON.stringify({
                                req: 'log_web_error',
                                error: {
                                    url,
                                    param,
                                    method,
                                    response: r
                                },
                                token
                            })
                        })
                        throw r
                    } else return [{
                        ...r
                    }]
                }
            }
        })
    } catch (e) {
        console.log(e)
        throw e
    }
}


async function login(
    uname,
    upass,
    persist = false,
    org_id = 101100010080006
) {
    if (!uname || !upass) {
        return null
    }
    let object = await fetch('/api/account/signin', {
        body: JSON.stringify({
            username: uname,
            password: upass,
            persist: !!persist,
            org_id
        }),
        method: 'POST'
    }).then(r => r.json())
    if (object.result.length) {
        let token = object.result[0].token
        store.commit('setGlobalToken', token)
        get_userinfo()
    }
    return object
}


async function login_by_code(code, code_type, red_url) {
    return db_api(
        'post',
        '/api/account/signin', {
        code,
        code_type,
        red_url
    },
    )
        .then(res => {
            let r = res[0].result
            if (r) {
                store.commit('setGlobalToken', r[0].token)
                return get_userinfo()
            } else {
                if (code_type === 'official_account' && code) {
                    iView.Message.warning({
                        background: true,
                        content: '请先绑定公众号！'
                    })
                    setTimeout(() => {
                        window.location.href = `https://biocore.sjtu.edu.cn/sjtu/single/bind.html?code=${code}`
                    }, 3000);
                } else {
                    return;
                }
            }
        })
}

function _isMobile() {
    return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    ) || document.body.clientWidth < 991
}

function logout() {
    store.commit('setUser', {
        current_org: {}
    });
    store.commit('setGlobalToken', '')
    return true
}

function GetQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}

Vue.prototype._isMobile = function () {
    return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    ) || document.body.clientWidth < 900
}

let code = GetQueryString('code');
let code_type = GetQueryString('code_type');
let red_url = GetQueryString('red_url');
if (GetQueryString('action') === 'logout') {
    logout()
}
console.log(store.state.user)
if (code && _isMobile()) {
    login_by_code(code, code_type, red_url).then(() => {
        new Vue({
            router,
            store,
            render: h => h(App, {
                ref: 'app',
            }),
        }).$mount('#app')
    })
} else {
    if (code) login_by_code(code, code_type, red_url);
    new Vue({
        router,
        store,
        render: h => h(App, {
            ref: 'app',
        }),
    }).$mount('#app')
}